import { render, staticRenderFns } from "./main.vue?vue&type=template&id=7fa02a7e&functional=true&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fa02a7e')) {
      api.createRecord('7fa02a7e', component.options)
    } else {
      api.rerender('7fa02a7e', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=7fa02a7e&functional=true&", function () {
      api.rerender('7fa02a7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/divider/src/main.vue"
export default component.exports